import React from 'react'
import './Random.css'
export default function Company() {
  return (
    <>
      <div className='random_div'>
      <h2>THis is the Company Page.
        loremaodfuosdfhisdavshvbkj xcv
        sdffsdfsdafdsda
        sdfsdfsadfasdfasd
        sfdafsadfsdafsadf
        sdafsadfsdfsafsdaf
      </h2>
      </div>
    </>
  )
}
